import { createContext, useContext } from 'react';
import type { BrandNames } from 'mp-cross';
import { enabledRebranding } from '../utils/rebranding';

type ProviderProps = {
  children: JSX.Element[] | JSX.Element
  appTheme: BrandNames
}

export type RebrandingContextProps = {
  isRebrandingEnabled: boolean
}

const RebrandingContext = createContext({} as RebrandingContextProps);

export const useRebranding = (): RebrandingContextProps => useContext(RebrandingContext);

export const RebrandingProvider = (props: ProviderProps) => {
  const { children, appTheme } = props;

  const isRebrandingEnabled = enabledRebranding(appTheme);

  return (
    <RebrandingContext.Provider value={{
      isRebrandingEnabled,
    }}
    >
      {children}
    </RebrandingContext.Provider>
  );
};
